{
  "manifest": {
    "id": "official-core",
    "version": "0.1.0",
    "manifest_version": 1
  },
  "entity_roots": [
    "location",
    "character",
    "faction",
    "event",
    "item",
    "lore"
  ],
  "predicates": [
    {
      "id": "pred_06b851f2-8bc3-4371-8f72-ded6ffb5896c",
      "value_kind": [
        "text"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Name"
      }
    },
    {
      "id": "pred_90928ac2-e67d-4b97-a63c-aac86c8d25d5",
      "value_kind": [
        "number"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Population"
      },
      "default_facet": "details"
    },
    {
      "id": "pred_735e6654-d388-47e3-8f67-59e0eb205991",
      "value_kind": [
        "text"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Government"
      },
      "default_facet": "details"
    },
    {
      "id": "pred_59449352-9c55-4b76-9543-3392de71d7f6",
      "value_kind": [
        "ref"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Canonical calendar"
      },
      "ref_root": "lore",
      "reciprocal": "canonical calendar of"
    },
    {
      "id": "pred_3fa6ef7f-dc8b-4cce-b775-c936a201e7f9",
      "value_kind": [
        "ref"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Display calendars"
      },
      "ref_root": "lore",
      "reciprocal": "displayed by",
      "uniqueness_key": [
        "object"
      ]
    },
    {
      "id": "pred_1771e7e9-b8ae-45ec-99dc-2e0d3704f1a5",
      "value_kind": [
        "text"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Accent color"
      }
    },
    {
      "id": "pred_5d237316-b439-448d-8afa-1a1f6c17ea3e",
      "value_kind": [
        "asset"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Hero image"
      }
    },
    {
      "id": "pred_3a768e45-a187-4fca-8594-53e876386abf",
      "value_kind": [
        "enum"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Prose voice"
      },
      "enum_values": [
        {
          "id": "enm_1ba68b0a-9d17-4a66-aa13-9b39c2176b34",
          "label": {
            "en": "Default"
          }
        },
        {
          "id": "enm_02644b01-2d20-4459-9ca2-d705cfc67345",
          "label": {
            "en": "Gritty"
          }
        },
        {
          "id": "enm_65cd25f1-2b88-4340-982d-7ee229014a34",
          "label": {
            "en": "Whimsical"
          }
        },
        {
          "id": "enm_94b45ba7-05cd-4fbd-8687-98a7b7fc81af",
          "label": {
            "en": "Pulp"
          }
        },
        {
          "id": "enm_5635134e-ccd9-40ac-afde-113e8fc8a42c",
          "label": {
            "en": "Noir"
          }
        },
        {
          "id": "enm_34839d67-7517-45f0-af11-ae4b3ca3e4b0",
          "label": {
            "en": "High Fantasy"
          }
        }
      ]
    },
    {
      "id": "pred_e28c4158-8b0a-4c2f-b22c-95bc74dc332d",
      "value_kind": [
        "rich_text"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Setting summary"
      }
    },
    {
      "id": "pred_d2342713-d7f6-4b6a-81c3-db7da30e663b",
      "value_kind": [
        "text"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Campaign kind"
      }
    },
    {
      "id": "pred_5d1697b9-7e90-42c9-ae8f-c74f3611dea2",
      "value_kind": [
        "ref"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Ruled by"
      },
      "ref_roots": [
        "character",
        "faction"
      ],
      "reciprocal": "rules",
      "uniqueness_key": []
    },
    {
      "id": "pred_a6df0471-8b05-43a5-874c-321dcbe7f172",
      "value_kind": [
        "ref"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Capital"
      },
      "ref_root": "location",
      "reciprocal": "capital of"
    },
    {
      "id": "pred_df4101e8-135e-4e5e-b5c4-28a7413f3554",
      "value_kind": [
        "containment"
      ],
      "merge": "rebase",
      "previous_names": [],
      "uniqueness_key": [
        "object"
      ],
      "label": {
        "en": "Contained in"
      },
      "ref_root": "location",
      "reciprocal": "contains"
    },
    {
      "id": "pred_e613a462-bebb-4348-bdea-75c5caa00bd6",
      "value_kind": [
        "rich_text"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Laws"
      }
    },
    {
      "id": "pred_6747aeef-6b60-4c3c-ba8b-8c8756991847",
      "value_kind": [
        "ref"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Species"
      },
      "ref_root": "lore",
      "reciprocal": "species of"
    },
    {
      "id": "pred_659f578b-c9b1-42e7-a016-8c2eae3ac61a",
      "value_kind": [
        "text"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Gender"
      },
      "default_facet": "appearance"
    },
    {
      "id": "pred_ee2d8ade-74bf-4c97-8311-808ec911c04f",
      "value_kind": [
        "rich_text"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Appearance"
      },
      "player_authority": true,
      "default_facet": "appearance"
    },
    {
      "id": "pred_ddc8e369-b41e-4f1a-99bb-c793788f6e1f",
      "value_kind": [
        "asset"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Portrait"
      },
      "player_authority": true,
      "default_facet": "appearance"
    },
    {
      "id": "pred_72a21aa0-db5e-4fe7-b45f-7411027e7cdb",
      "value_kind": [
        "game_date"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Born in"
      }
    },
    {
      "id": "pred_999349d0-d179-4db8-ba49-574c15fef067",
      "value_kind": [
        "game_date"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Died in"
      },
      "default_facet": "secrets"
    },
    {
      "id": "pred_e279187f-515e-45a9-a64c-532e0f72d48b",
      "value_kind": [
        "text"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Cause of death"
      },
      "default_facet": "secrets"
    },
    {
      "id": "pred_71cb4f5b-ac65-4fde-98bf-f79476e4c4f1",
      "value_kind": [
        "text"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Claim to fame"
      }
    },
    {
      "id": "pred_76123ed0-d207-4213-8795-e881701259f2",
      "value_kind": [
        "text"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Reputation"
      }
    },
    {
      "id": "pred_9f74d658-6ec5-4aad-92aa-456446114cd6",
      "value_kind": [
        "rich_text"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Known for"
      }
    },
    {
      "id": "pred_d8ae12ef-c396-46a9-8477-90b56ff288de",
      "value_kind": [
        "rich_text"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Magical properties"
      }
    },
    {
      "id": "pred_9e348f2a-a360-4449-8379-4e103d7924f4",
      "value_kind": [
        "ref"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "School"
      },
      "ref_root": "lore",
      "reciprocal": "practised by"
    },
    {
      "id": "pred_9681ccff-bded-4f20-8aec-b0224d1791c1",
      "value_kind": [
        "ref"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Bound to"
      },
      "ref_roots": [
        "character",
        "faction",
        "item",
        "location",
        "event",
        "lore"
      ],
      "reciprocal": "bearer of"
    },
    {
      "id": "pred_6ffae8ed-126b-4fe6-896c-a86fd45bdcb1",
      "value_kind": [
        "game_date",
        "game_date_range"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Occurred at"
      }
    },
    {
      "id": "pred_597c4868-787b-409f-bff0-c28e2cc3df81",
      "value_kind": [
        "ref"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Participants"
      },
      "ref_roots": [
        "character",
        "faction"
      ],
      "reciprocal": "took part in",
      "uniqueness_key": [
        "object"
      ]
    },
    {
      "id": "pred_ecc561cb-e10f-4b3e-934a-3fd48210a23e",
      "value_kind": [
        "ref"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Location"
      },
      "ref_root": "location",
      "reciprocal": "site of"
    },
    {
      "id": "pred_05fef77e-c286-4324-bfa9-7922a7683a11",
      "value_kind": [
        "ref"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Caused by"
      },
      "ref_root": "event",
      "reciprocal": "led to",
      "uniqueness_key": [
        "object"
      ]
    },
    {
      "id": "pred_7fa92b99-beaa-4865-af18-d6996f67ac2e",
      "value_kind": [
        "ref"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Precedes"
      },
      "ref_root": "event",
      "reciprocal": "preceded by",
      "uniqueness_key": [
        "object"
      ]
    },
    {
      "id": "pred_e56502a5-8809-4261-82b5-bc0faf744a0e",
      "value_kind": [
        "recurrence_rule"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Recurs as"
      },
      "uniqueness_key": [
        "object"
      ]
    },
    {
      "id": "pred_077b1ca2-c6f7-4777-878f-32e1236f1e5a",
      "value_kind": [
        "rich_text"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Objective"
      }
    },
    {
      "id": "pred_c35ec8bf-4d41-45da-8675-0c4bed95f3c0",
      "value_kind": [
        "text"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Reward"
      }
    },
    {
      "id": "pred_6f0e44fd-4fe2-4013-880d-6534f58aa1be",
      "value_kind": [
        "enum"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Quest status"
      },
      "enum_values": [
        {
          "id": "enm_ef9f213f-aa1c-404d-aabc-db9a47340ab0",
          "label": {
            "en": "Open"
          }
        },
        {
          "id": "enm_ddf910df-edc1-49ae-bcb4-f4b8c0542ded",
          "label": {
            "en": "Active"
          }
        },
        {
          "id": "enm_b02ab7b8-d661-456d-a8a2-429d5f8f20d1",
          "label": {
            "en": "Completed"
          }
        },
        {
          "id": "enm_c330b09b-0985-49a0-bfe6-3a242131efb7",
          "label": {
            "en": "Failed"
          }
        }
      ]
    },
    {
      "id": "pred_5f8af83f-4f80-4e49-82b4-a0c6013f13d7",
      "value_kind": [
        "ref"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Giver"
      },
      "ref_roots": [
        "character",
        "faction"
      ],
      "reciprocal": "offered by"
    },
    {
      "id": "pred_bdb25792-51ff-456d-83dd-c42044beb2a4",
      "value_kind": [
        "real_datetime_range"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Real world span"
      }
    },
    {
      "id": "pred_45190650-81fe-4cc5-9557-2d25247b0ea0",
      "value_kind": [
        "rich_text"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Summary"
      }
    },
    {
      "id": "pred_6185003a-ea0a-4f05-a06d-d453d0a896f4",
      "value_kind": [
        "number"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Session number"
      }
    },
    {
      "id": "pred_d35b7f01-e70a-4aa0-b6fb-00d16ea61ac8",
      "value_kind": [
        "enum"
      ],
      "merge": "lww",
      "previous_names": [],
      "label": {
        "en": "Pending auto ratify policy"
      },
      "enum_values": [
        {
          "id": "enm_6337a59c-861c-4d67-9dd9-5ce28e289846",
          "label": {
            "en": "Manual"
          }
        },
        {
          "id": "enm_672b2d60-f7a1-47d5-881b-661d080be9e4",
          "label": {
            "en": "Auto Ratify"
          }
        },
        {
          "id": "enm_8f2aeddb-a10a-4632-8e24-3f6c9a3c6bb4",
          "label": {
            "en": "Appear As Pending"
          }
        }
      ]
    },
    {
      "id": "pred_8b87ec8b-7c7f-4690-a88d-641a8b0a1f1b",
      "value_kind": [
        "text"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Controlled by"
      },
      "uniqueness_key": [
        "object"
      ]
    },
    {
      "id": "pred_a5396199-a0e6-4f82-94b7-2c1f48a0163d",
      "value_kind": [
        "ref"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Visited"
      },
      "ref_root": "location",
      "reciprocal": "visited by",
      "player_authority": true,
      "uniqueness_key": [
        "object"
      ]
    },
    {
      "id": "pred_98d48d14-4b0e-45fe-bbd3-66794fe8572a",
      "value_kind": [
        "text"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Creature kind"
      }
    },
    {
      "id": "pred_95b677b8-a37c-41a2-92c4-b4852762f2a4",
      "value_kind": [
        "enum"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Size"
      },
      "enum_values": [
        {
          "id": "enm_70fa672c-bb51-4e3d-b145-0f800ea6dc0e",
          "label": {
            "en": "Tiny"
          }
        },
        {
          "id": "enm_f9c6197f-b41c-4761-823c-ff6b73c4514e",
          "label": {
            "en": "Small"
          }
        },
        {
          "id": "enm_e53539bb-10c3-4807-abea-49866c3e3cf5",
          "label": {
            "en": "Medium"
          }
        },
        {
          "id": "enm_f95d09ea-0b0b-4e50-86e4-b1c454f18d4c",
          "label": {
            "en": "Large"
          }
        },
        {
          "id": "enm_352429f0-b3ca-4589-884d-397e2577c718",
          "label": {
            "en": "Huge"
          }
        },
        {
          "id": "enm_7c6e525a-2c19-4af4-aa49-964e5521eb73",
          "label": {
            "en": "Gargantuan"
          }
        }
      ]
    },
    {
      "id": "pred_005c78d6-b4ed-44fa-b3a6-a0fe7851882b",
      "value_kind": [
        "text"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Habitat"
      }
    },
    {
      "id": "pred_426ff26a-0839-40b0-bf56-5cc7e4101196",
      "value_kind": [
        "ref"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Rider"
      },
      "ref_root": "character",
      "reciprocal": "mount"
    },
    {
      "id": "pred_8454a183-d490-43e0-9ae3-5ed5c6e896f9",
      "value_kind": [
        "number"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Carrying capacity"
      }
    },
    {
      "id": "pred_358df233-4155-4cab-a53f-0268ed20484b",
      "value_kind": [
        "text"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Temperament"
      }
    },
    {
      "id": "pred_a727d5a8-28b6-411c-bae0-26eae0d2f73d",
      "value_kind": [
        "ref"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Instance of"
      },
      "ref_root": "lore",
      "reciprocal": "instances"
    },
    {
      "id": "pred_e584ac52-cfe1-4c0d-b210-a01c601530c7",
      "value_kind": [
        "ref"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Subject"
      },
      "ref_roots": [
        "location",
        "character",
        "faction",
        "event",
        "item",
        "lore"
      ],
      "reciprocal": "depicted by"
    },
    {
      "id": "pred_90fb71c9-bac2-4f35-8f63-f967c8dc9d3b",
      "value_kind": [
        "text"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Representation"
      },
      "featured": true
    },
    {
      "id": "pred_a3e687eb-44f8-4f17-bd7b-9f1897f357cb",
      "value_kind": [
        "interior_frame"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Frame override"
      }
    },
    {
      "id": "pred_fda4b9b5-6b1a-458a-ba42-38a589da542e",
      "value_kind": [
        "asset"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Background"
      }
    },
    {
      "id": "pred_9b3ffec5-7a40-40a0-97db-4f3b6fd72222",
      "value_kind": [
        "text"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Layers"
      },
      "uniqueness_key": [
        "object"
      ]
    },
    {
      "id": "pred_0dcbdbc2-fbb6-44b4-a530-27023d2e08df",
      "value_kind": [
        "ref"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Parent depiction"
      },
      "ref_root": "lore",
      "reciprocal": "child depictions"
    },
    {
      "id": "pred_a0a9da35-6bd4-4f4c-ae83-1b68a8bc79ef",
      "value_kind": [
        "text",
        "number"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Scale"
      }
    },
    {
      "id": "pred_082dbe38-934c-4fd5-becf-9a2074f60b1f",
      "value_kind": [
        "text"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Projection"
      }
    },
    {
      "id": "pred_a249c3e7-de07-468b-8c0f-8613743a895d",
      "value_kind": [
        "rich_text"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Style"
      },
      "rich_text_mode": "minimal"
    },
    {
      "id": "pred_a61099c1-450e-4ea8-97f5-a29f47602298",
      "value_kind": [
        "enum"
      ],
      "merge": "rebase",
      "previous_names": [],
      "label": {
        "en": "Orientation"
      },
      "enum_values": [
        {
          "id": "enm_58c22399-e126-47c8-9ef0-f159a8fb8088",
          "label": {
            "en": "North up"
          }
        },
        {
          "id": "enm_2ea29264-d64a-4bdb-8d6a-fcfc56b5fa32",
          "label": {
            "en": "East up"
          }
        },
        {
          "id": "enm_f051225d-53cd-48f7-8a40-044dbc0f3437",
          "label": {
            "en": "None"
          }
        }
      ]
    }
  ],
  "traits": [
    {
      "id": "trait_583b1c12-540c-474d-bdfe-8aee96b6ddef",
      "applies_to": [
        "location"
      ],
      "predicates": [
        "pred_90928ac2-e67d-4b97-a63c-aac86c8d25d5",
        "pred_735e6654-d388-47e3-8f67-59e0eb205991"
      ],
      "label": {
        "en": "Inhabited"
      },
      "default_facets": [
        {
          "id": "details",
          "label": "Details",
          "safe_to_bulk_reveal": true
        }
      ]
    },
    {
      "id": "trait_6a9dc0c5-6f90-49ce-b8ae-cd65419e33bb",
      "applies_to": [
        "lore"
      ],
      "predicates": [
        "pred_59449352-9c55-4b76-9543-3392de71d7f6",
        "pred_3fa6ef7f-dc8b-4cce-b775-c936a201e7f9",
        "pred_1771e7e9-b8ae-45ec-99dc-2e0d3704f1a5",
        "pred_5d237316-b439-448d-8afa-1a1f6c17ea3e",
        "pred_3a768e45-a187-4fca-8594-53e876386abf",
        "pred_e28c4158-8b0a-4c2f-b22c-95bc74dc332d",
        "pred_d2342713-d7f6-4b6a-81c3-db7da30e663b",
        "pred_d35b7f01-e70a-4aa0-b6fb-00d16ea61ac8"
      ],
      "label": {
        "en": "Campaign"
      }
    },
    {
      "id": "trait_d1848314-b7c7-4dbd-bc4e-a88d116db79b",
      "applies_to": [
        "location",
        "faction"
      ],
      "predicates": [
        "pred_735e6654-d388-47e3-8f67-59e0eb205991",
        "pred_5d1697b9-7e90-42c9-ae8f-c74f3611dea2",
        "pred_a6df0471-8b05-43a5-874c-321dcbe7f172",
        "pred_e613a462-bebb-4348-bdea-75c5caa00bd6"
      ],
      "label": {
        "en": "Governed"
      }
    },
    {
      "id": "trait_7d19205c-bb26-443f-b949-5bf0e5c73904",
      "applies_to": [
        "character"
      ],
      "predicates": [
        "pred_6747aeef-6b60-4c3c-ba8b-8c8756991847",
        "pred_659f578b-c9b1-42e7-a016-8c2eae3ac61a",
        "pred_ee2d8ade-74bf-4c97-8311-808ec911c04f",
        "pred_ddc8e369-b41e-4f1a-99bb-c793788f6e1f"
      ],
      "label": {
        "en": "Embodied"
      },
      "default_facets": [
        {
          "id": "appearance",
          "label": "Appearance",
          "safe_to_bulk_reveal": true
        }
      ]
    },
    {
      "id": "trait_b73ea838-f937-4d4a-b837-7612036d409e",
      "applies_to": [
        "character"
      ],
      "predicates": [
        "pred_72a21aa0-db5e-4fe7-b45f-7411027e7cdb",
        "pred_999349d0-d179-4db8-ba49-574c15fef067",
        "pred_e279187f-515e-45a9-a64c-532e0f72d48b"
      ],
      "label": {
        "en": "Mortal"
      },
      "default_facets": [
        {
          "id": "secrets",
          "label": "Secrets",
          "safe_to_bulk_reveal": false
        }
      ]
    },
    {
      "id": "trait_67f55d1f-6b7b-4534-a158-96c1c3147e8d",
      "applies_to": [
        "character",
        "item",
        "location"
      ],
      "predicates": [
        "pred_71cb4f5b-ac65-4fde-98bf-f79476e4c4f1",
        "pred_76123ed0-d207-4213-8795-e881701259f2",
        "pred_9f74d658-6ec5-4aad-92aa-456446114cd6"
      ],
      "label": {
        "en": "Notable"
      }
    },
    {
      "id": "trait_7482796a-d0a0-4d94-9bc2-d392a45fd4a0",
      "applies_to": [
        "item",
        "location",
        "character"
      ],
      "predicates": [
        "pred_d8ae12ef-c396-46a9-8477-90b56ff288de",
        "pred_9e348f2a-a360-4449-8379-4e103d7924f4",
        "pred_9681ccff-bded-4f20-8aec-b0224d1791c1"
      ],
      "label": {
        "en": "Magical"
      }
    },
    {
      "id": "trait_cac9c54a-6d68-489b-b916-b3a51f5e91c4",
      "applies_to": [
        "event"
      ],
      "predicates": [
        "pred_6ffae8ed-126b-4fe6-896c-a86fd45bdcb1",
        "pred_597c4868-787b-409f-bff0-c28e2cc3df81",
        "pred_ecc561cb-e10f-4b3e-934a-3fd48210a23e",
        "pred_05fef77e-c286-4324-bfa9-7922a7683a11",
        "pred_7fa92b99-beaa-4865-af18-d6996f67ac2e",
        "pred_e56502a5-8809-4261-82b5-bc0faf744a0e"
      ],
      "label": {
        "en": "Scheduled"
      }
    },
    {
      "id": "trait_6927d058-b89b-42b5-beb0-4b4eb2787f80",
      "applies_to": [
        "event"
      ],
      "predicates": [
        "pred_077b1ca2-c6f7-4777-878f-32e1236f1e5a",
        "pred_c35ec8bf-4d41-45da-8675-0c4bed95f3c0",
        "pred_6f0e44fd-4fe2-4013-880d-6534f58aa1be",
        "pred_5f8af83f-4f80-4e49-82b4-a0c6013f13d7"
      ],
      "label": {
        "en": "Quest"
      }
    },
    {
      "id": "trait_2d9bacaa-276a-4fe2-9918-ea38a8ba08bd",
      "applies_to": [
        "event"
      ],
      "predicates": [
        "pred_bdb25792-51ff-456d-83dd-c42044beb2a4",
        "pred_45190650-81fe-4cc5-9557-2d25247b0ea0",
        "pred_6185003a-ea0a-4f05-a06d-d453d0a896f4"
      ],
      "label": {
        "en": "Session"
      }
    },
    {
      "id": "trait_7c628628-8d72-4a5c-be2d-135ad22e28e0",
      "applies_to": [
        "character"
      ],
      "predicates": [
        "pred_a5396199-a0e6-4f82-94b7-2c1f48a0163d"
      ],
      "label": {
        "en": "Traveler"
      }
    },
    {
      "id": "trait_b0ee7ba7-bd8c-4784-b238-df19a9ae5ba0",
      "applies_to": [
        "character"
      ],
      "predicates": [
        "pred_98d48d14-4b0e-45fe-bbd3-66794fe8572a",
        "pred_95b677b8-a37c-41a2-92c4-b4852762f2a4",
        "pred_005c78d6-b4ed-44fa-b3a6-a0fe7851882b"
      ],
      "label": {
        "en": "Creature"
      },
      "description": {
        "en": "A non-humanoid living thing — its kind, size, and where it lives."
      }
    },
    {
      "id": "trait_8e55a07e-803f-453f-9095-266f00015df0",
      "applies_to": [
        "character"
      ],
      "predicates": [
        "pred_426ff26a-0839-40b0-bf56-5cc7e4101196",
        "pred_8454a183-d490-43e0-9ae3-5ed5c6e896f9",
        "pred_358df233-4155-4cab-a53f-0268ed20484b"
      ],
      "label": {
        "en": "Mount"
      },
      "description": {
        "en": "A rideable companion — who rides it, what it can carry, its temperament."
      }
    },
    {
      "id": "trait_35883d22-f123-4be5-b691-f96137e5414d",
      "applies_to": [
        "lore"
      ],
      "predicates": [
        "pred_e584ac52-cfe1-4c0d-b210-a01c601530c7",
        "pred_90fb71c9-bac2-4f35-8f63-f967c8dc9d3b",
        "pred_a3e687eb-44f8-4f17-bd7b-9f1897f357cb",
        "pred_fda4b9b5-6b1a-458a-ba42-38a589da542e",
        "pred_9b3ffec5-7a40-40a0-97db-4f3b6fd72222",
        "pred_0dcbdbc2-fbb6-44b4-a530-27023d2e08df"
      ],
      "label": {
        "en": "Depicts"
      },
      "description": {
        "en": "A representation of an entity (Maps are the v1 specialization). Carries the thing depicted, a representation label, an optional background image, visual layers, and a parent depiction for cross-scale navigation."
      }
    },
    {
      "id": "trait_e436ddf0-2b68-4403-8425-115ef8f49517",
      "applies_to": [
        "lore"
      ],
      "predicates": [
        "pred_a0a9da35-6bd4-4f4c-ae83-1b68a8bc79ef",
        "pred_082dbe38-934c-4fd5-becf-9a2074f60b1f",
        "pred_a249c3e7-de07-468b-8c0f-8613743a895d",
        "pred_a61099c1-450e-4ea8-97f5-a29f47602298"
      ],
      "label": {
        "en": "Cartographic"
      },
      "description": {
        "en": "Pairs with Depicts to define a Map: declared scale, cartographic projection (v1 supports 'flat'), visual style, and orientation. Soft-constrains the subject to a Location (the auditor warns, never blocks)."
      }
    }
  ],
  "types": [
    {
      "id": "npc",
      "root": "character",
      "traits": [
        "trait_7d19205c-bb26-443f-b949-5bf0e5c73904",
        "trait_b73ea838-f937-4d4a-b837-7612036d409e",
        "trait_67f55d1f-6b7b-4534-a158-96c1c3147e8d"
      ],
      "label": {
        "en": "NPC"
      },
      "description": {
        "en": "A named person — appearance, lifecycle, and what they're known for."
      }
    },
    {
      "id": "dragon",
      "root": "character",
      "traits": [
        "trait_7d19205c-bb26-443f-b949-5bf0e5c73904",
        "trait_b73ea838-f937-4d4a-b837-7612036d409e",
        "trait_7482796a-d0a0-4d94-9bc2-d392a45fd4a0",
        "trait_67f55d1f-6b7b-4534-a158-96c1c3147e8d",
        "trait_b0ee7ba7-bd8c-4784-b238-df19a9ae5ba0"
      ],
      "label": {
        "en": "Dragon"
      },
      "description": {
        "en": "A great magical beast — embodied, magical, and creature traits."
      }
    },
    {
      "id": "beast",
      "root": "character",
      "traits": [
        "trait_7d19205c-bb26-443f-b949-5bf0e5c73904",
        "trait_b73ea838-f937-4d4a-b837-7612036d409e",
        "trait_b0ee7ba7-bd8c-4784-b238-df19a9ae5ba0"
      ],
      "label": {
        "en": "Beast"
      },
      "description": {
        "en": "A non-humanoid creature."
      }
    },
    {
      "id": "mount",
      "root": "character",
      "traits": [
        "trait_7d19205c-bb26-443f-b949-5bf0e5c73904",
        "trait_b73ea838-f937-4d4a-b837-7612036d409e",
        "trait_8e55a07e-803f-453f-9095-266f00015df0"
      ],
      "label": {
        "en": "Mount"
      },
      "description": {
        "en": "A rideable companion (horse, griffon, dire wolf)."
      }
    }
  ],
  "calendars": [
    {
      "id": "gregorian",
      "label": {
        "en": "Gregorian"
      },
      "cycles": {
        "year": {
          "months": [
            {
              "name": "january",
              "label": {
                "en": "January"
              },
              "length": 31
            },
            {
              "name": "february",
              "label": {
                "en": "February"
              },
              "length": 28,
              "leap_length": 29
            },
            {
              "name": "march",
              "label": {
                "en": "March"
              },
              "length": 31
            },
            {
              "name": "april",
              "label": {
                "en": "April"
              },
              "length": 30
            },
            {
              "name": "may",
              "label": {
                "en": "May"
              },
              "length": 31
            },
            {
              "name": "june",
              "label": {
                "en": "June"
              },
              "length": 30
            },
            {
              "name": "july",
              "label": {
                "en": "July"
              },
              "length": 31
            },
            {
              "name": "august",
              "label": {
                "en": "August"
              },
              "length": 31
            },
            {
              "name": "september",
              "label": {
                "en": "September"
              },
              "length": 30
            },
            {
              "name": "october",
              "label": {
                "en": "October"
              },
              "length": 31
            },
            {
              "name": "november",
              "label": {
                "en": "November"
              },
              "length": 30
            },
            {
              "name": "december",
              "label": {
                "en": "December"
              },
              "length": 31
            }
          ]
        },
        "week": {
          "labels": [
            {
              "name": "monday",
              "label": {
                "en": "Monday"
              }
            },
            {
              "name": "tuesday",
              "label": {
                "en": "Tuesday"
              }
            },
            {
              "name": "wednesday",
              "label": {
                "en": "Wednesday"
              }
            },
            {
              "name": "thursday",
              "label": {
                "en": "Thursday"
              }
            },
            {
              "name": "friday",
              "label": {
                "en": "Friday"
              }
            },
            {
              "name": "saturday",
              "label": {
                "en": "Saturday"
              }
            },
            {
              "name": "sunday",
              "label": {
                "en": "Sunday"
              }
            }
          ],
          "phase": 0
        }
      },
      "eras": [
        {
          "id": "bce",
          "name": "Before Common Era",
          "label": {
            "en": "Before Common Era"
          },
          "abbreviation": "BCE",
          "start_day": -365,
          "year_one": 1,
          "direction": "backward"
        },
        {
          "id": "ce",
          "name": "Common Era",
          "label": {
            "en": "Common Era"
          },
          "abbreviation": "CE",
          "start_day": 0,
          "year_one": 1,
          "direction": "forward"
        }
      ],
      "leap_rule": {
        "kind": "gregorian"
      },
      "anchor_canonical_day": -365
    },
    {
      "id": "harptos",
      "label": {
        "en": "Calendar of Harptos"
      },
      "cycles": {
        "year": {
          "months": [
            {
              "name": "hammer",
              "label": {
                "en": "Hammer"
              },
              "length": 30
            },
            {
              "name": "midwinter",
              "label": {
                "en": "Midwinter"
              },
              "length": 1,
              "intercalary": true
            },
            {
              "name": "alturiak",
              "label": {
                "en": "Alturiak"
              },
              "length": 30
            },
            {
              "name": "ches",
              "label": {
                "en": "Ches"
              },
              "length": 30
            },
            {
              "name": "tarsakh",
              "label": {
                "en": "Tarsakh"
              },
              "length": 30
            },
            {
              "name": "greengrass",
              "label": {
                "en": "Greengrass"
              },
              "length": 1,
              "intercalary": true
            },
            {
              "name": "mirtul",
              "label": {
                "en": "Mirtul"
              },
              "length": 30
            },
            {
              "name": "kythorn",
              "label": {
                "en": "Kythorn"
              },
              "length": 30
            },
            {
              "name": "flamerule",
              "label": {
                "en": "Flamerule"
              },
              "length": 30
            },
            {
              "name": "midsummer",
              "label": {
                "en": "Midsummer"
              },
              "length": 1,
              "leap_length": 2,
              "intercalary": true
            },
            {
              "name": "eleasis",
              "label": {
                "en": "Eleasis"
              },
              "length": 30
            },
            {
              "name": "eleint",
              "label": {
                "en": "Eleint"
              },
              "length": 30
            },
            {
              "name": "highharvestide",
              "label": {
                "en": "Highharvestide"
              },
              "length": 1,
              "intercalary": true
            },
            {
              "name": "marpenoth",
              "label": {
                "en": "Marpenoth"
              },
              "length": 30
            },
            {
              "name": "uktar",
              "label": {
                "en": "Uktar"
              },
              "length": 30
            },
            {
              "name": "feast_of_the_moon",
              "label": {
                "en": "Feast of the Moon"
              },
              "length": 1,
              "intercalary": true
            },
            {
              "name": "nightal",
              "label": {
                "en": "Nightal"
              },
              "length": 30
            }
          ]
        },
        "week": {
          "labels": [
            {
              "name": "first",
              "label": {
                "en": "1st"
              }
            },
            {
              "name": "second",
              "label": {
                "en": "2nd"
              }
            },
            {
              "name": "third",
              "label": {
                "en": "3rd"
              }
            },
            {
              "name": "fourth",
              "label": {
                "en": "4th"
              }
            },
            {
              "name": "fifth",
              "label": {
                "en": "5th"
              }
            },
            {
              "name": "sixth",
              "label": {
                "en": "6th"
              }
            },
            {
              "name": "seventh",
              "label": {
                "en": "7th"
              }
            },
            {
              "name": "eighth",
              "label": {
                "en": "8th"
              }
            },
            {
              "name": "ninth",
              "label": {
                "en": "9th"
              }
            },
            {
              "name": "tenth",
              "label": {
                "en": "10th"
              }
            }
          ],
          "phase": 0
        }
      },
      "eras": [
        {
          "id": "dr",
          "name": "Dale Reckoning",
          "label": {
            "en": "Dale Reckoning"
          },
          "abbreviation": "DR",
          "start_day": 0,
          "year_one": 1,
          "direction": "forward"
        }
      ],
      "leap_rule": {
        "kind": "every_n_years",
        "every": 4,
        "phase": 0
      },
      "anchor_canonical_day": 0
    }
  ]
}
